import ResourceCard from './ResourceCard';

export { type InsightResource } from './ResourceCard';
export default ResourceCard;
